document.addEventListener('DOMContentLoaded', () => {
  initCardSwatchFunctionality();
})

function initCardSwatchFunctionality(isRunningDefaultControl) {
  const swatch_items = [...document.querySelectorAll('.swatch-item')];
  swatch_items.forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
  
      //find all items siblings and remove class active
      const siblings = [...this.parentElement.children];
      siblings.forEach(function (sibling) {
        sibling.classList.remove('active');
      });

      item.classList.toggle('active');
      const { swatchColor } = this.dataset;
      
      const currentCardWrapper = this.closest('.card-wrapper')
      if (!!currentCardWrapper) {
        const currentImgDetected = currentCardWrapper.querySelector(`.dtc-card__carousel .product__media-item img[alt="${ swatchColor }"]`)
        if (!!!currentImgDetected) return;
    
        const slideToGo = currentImgDetected.closest('.slider__slide');
        if (!!!slideToGo) return;
        slideToGo.parentElement.scrollTo({ left: slideToGo.offsetLeft });
        
        return
      }
  
      const { swatchselector, swatchproductindentifier } = this.dataset;
      const variantImage = document.querySelector(`img[data-product-identifier="${swatchproductindentifier}"]`);
      const variantImageValue = variantImage.getAttribute(`data-variant-image-${swatchselector}`);
      variantImage.removeAttribute("srcset");
      variantImage.src = variantImageValue;
    });
  })
}
